import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Message = styled(Typography)`
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

export const Container = styled(Box)`
  display: flex;
  width: 100%;
  height: 100%;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
